import { PasswordSchema as c, UsernameSchema as s, RefreshTokenSchema as m, BearerTokenTypeSchema as h, AccessTokenSchema as b, UserIdSchema as n } from "@hprofits/shared";
import { PrivilegeSchema as p, UserRoleSchema as t } from "@hprofits/shared/auth";
import { z as e } from "zod";
const _ = e.object({
  username: s,
  password: c
}).strict().readonly(), r = e.string().min(1), I = e.object({
  username: s,
  password: c,
  captchaToken: r.optional()
}).strict().readonly(), N = e.object({
  siteKey: e.string().min(1)
}).readonly(), w = e.object({
  refresh_token: m
}).strict().readonly(), y = e.object({
  access_token: b,
  token_type: h,
  expires_in: e.number().int().positive(),
  refresh_token: m
}).readonly(), x = y, u = e.object({
  id: n,
  username: s
}).readonly(), R = e.array(e.string()).transform(
  (S) => S.flatMap((g) => {
    const i = p.safeParse(g);
    return i.success ? [i.data] : [];
  })
).readonly(), E = e.object({
  id: n,
  username: s,
  title: e.string().min(1).optional(),
  privileges: R,
  roles: e.array(t).readonly(),
  activeRole: t.optional(),
  impersonatedBy: u.optional(),
  // `dict_user_grants` ids given to the user, e.g. the right to submit custom content. They belong to the user,
  // not to a role. Defaulted so that a client built with this field still reads the answer of a backend deployed
  // before it.
  grants: e.array(e.number().int()).readonly().default([])
}).readonly(), M = e.object({
  role: t
}).strict().readonly(), L = e.object({
  userId: n
}).readonly(), f = e.string().regex(/^[0-9a-f]{8}$/), v = e.object({
  slot: f
}).readonly(), A = e.object({
  id: n,
  email: e.string(),
  fullName: e.string(),
  isBanned: e.boolean()
}).readonly(), U = e.object({
  message: e.string()
}).readonly(), l = e.enum(["telegram"]), o = 100, d = 100, C = e.object({
  id: n,
  email: e.string(),
  isEmailVerified: e.boolean(),
  firstName: e.string(),
  lastName: e.string(),
  messenger: e.string().nullable(),
  messengerId: e.string().nullable(),
  isSubscribed: e.boolean()
}).readonly(), q = e.object({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  messenger: l.nullable(),
  messengerId: e.string().trim().min(1).max(d).nullable(),
  isSubscribed: e.boolean()
}).strict().readonly(), a = 6, G = e.object({
  oldPassword: e.string().min(1),
  newPassword: e.string().min(a)
}).strict().readonly(), j = t.extract(["Publisher", "Advert"]), B = e.object({
  firstName: e.string().trim().min(1).max(o),
  lastName: e.string().trim().min(1).max(o),
  email: s,
  messenger: l,
  messengerId: e.string().trim().min(1).max(d),
  password: e.string().min(a),
  roles: e.array(j).min(1).readonly(),
  isSubscribed: e.boolean(),
  acceptTerms: e.literal(!0),
  captchaToken: r.optional()
}).strict().readonly(), H = e.object({
  email: s,
  captchaToken: r.optional()
}).strict().readonly(), O = e.object({
  token: e.string().trim().min(1),
  password: e.string().min(a)
}).strict().readonly();
export {
  N as CaptchaConfigSchema,
  r as CaptchaTokenSchema,
  G as ChangePasswordSchema,
  A as ImpersonationUserSchema,
  _ as LoginCredentialsSchema,
  U as MessageResponseSchema,
  a as PASSWORD_MIN_LENGTH,
  d as PROFILE_MESSENGER_ID_MAX_LENGTH,
  o as PROFILE_NAME_MAX_LENGTH,
  H as PasswordResetRequestSchema,
  O as PasswordResetSchema,
  l as ProfileMessengerSchema,
  C as ProfileSchema,
  w as RefreshTokenRequestSchema,
  x as RefreshTokenResponseSchema,
  j as RegistrationRoleSchema,
  B as RegistrationSchema,
  u as SessionImpersonatorSchema,
  I as SessionLoginSchema,
  M as SessionRoleRequestSchema,
  f as SessionSlotSchema,
  E as SessionUserSchema,
  L as StartImpersonationRequestSchema,
  v as StartImpersonationResultSchema,
  y as TokenResponseSchema,
  q as UpdateProfileSchema
};
//# sourceMappingURL=schemas.js.map
